import { MatDialogConfig } from '@angular/material/dialog';

/** Panel classes for the two account dialogs (Profile / Contact), opened as a plain centered
 *  card. Sizing lives in styles.css under these classes. */
export const PROFILE_DIALOG_PANEL = 'pa-profile-dialog-panel';
export const CONTACT_DIALOG_PANEL = 'pa-contact-dialog-panel';

/**
 * MatDialog config for Profile / Contact: no `position` override, so MatDialog's default overlay
 * centers the pane both horizontally and vertically (previously anchored top-right — PDT-35726 —
 * moved back to centered per follow-up feedback). The card draws its own frame (payarc-dialog-shell)
 * rather than Material's, so the MDC surface is made transparent via Material's dialog tokens (see
 * .pa-account-dialog in styles.css). Every caller that opens these dialogs must use this, so they
 * all render the same.
 */
export function accountDialogConfig<D = any>(panelClass: string, extra: MatDialogConfig<D> = {}): MatDialogConfig<D> {
  return {
    ...extra,
    panelClass: ['pa-account-dialog', panelClass],
    // Default MDC caps the dialog at 80vw / 560px; the cards size themselves (see component CSS).
    maxWidth: '100vw',
  };
}
